import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_team_management-insider_marketing_page_learn_more_redirect-click';

/**
 * Event to track user without checkout permissions being redirected to insider marketing page
 */
export function trackRetailerTeamManagementInsiderMarketingPageLearnMoreRedirectClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { customParameterToken },
  });
}
